import { render, staticRenderFns } from "./rebase_confirmation_dialog.vue?vue&type=template&id=55bbcae4"
import script from "./rebase_confirmation_dialog.vue?vue&type=script&lang=js"
export * from "./rebase_confirmation_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports